import { Box, Card, CardContent, Grid2, Typography } from "@mui/material";

import { useEffect, useState } from "react";
import { DataService } from "../services/DataService";
import { _ROUTES } from "../utils/_routes_constants";

export const Dashboard = () => {
  // const { roles, userRole, isUserAllowed } = AppRights.getUserRoles();
  const [indicators, setIndicators] = useState([]);
  const dataService = new DataService();

  useEffect(() => {
    if (indicators.length === 0) {
      dataService.doRequest(
        "GET",
        _ROUTES.DASHBOARD_INDICATORS,
        null,
        null,
        (data) => {
          setIndicators(data);
        },
      );
    }
  }, []);

  return (
    <>
      {/* <AppRights roles={[...roles, isUserAllowed ? userRole : null]} /> */}
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}
      >
        <Grid2
          container
          spacing={3}
          fullWidth
          className="d-flex justify-content-between"
        >
          {indicators.map((indicator, index) => (
            <Grid2 item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  minHeight: "150px",
                  width: "100%",
                  backgroundColor: "grey",
                  borderRadius: 5,
                  boxShadow: 5,
                }}
              >
                <CardContent>
                  <Typography
                    sx={{
                      color: "#FFD769",
                      fontWeight: "bold",
                      fontSize: "1.5em",
                    }}
                  >
                    {indicator.title}
                  </Typography>
                  {/** si indicator.value est un tableau  */}
                  {Array.isArray(indicator.value) ? (
                    <ul>
                      {indicator.value.map((item, idx) => (
                        <li
                          key={idx}
                          sx={{
                            listStyle: "none",
                            margin: "8px 0",
                            color: "white",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ color: "white", fontSize: "1em" }}
                          >
                            {item}
                          </Typography>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <Typography
                      sx={{
                        color: "white",
                        fontSize: "1.5em",
                        textAlign: "center",
                        marginTop: "16px",
                      }}
                    >
                      {indicator.value}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid2>
          ))}
        </Grid2>
      </Box>
    </>
  );
};

export default Dashboard;
